export default __webpack_public_path__ + "047db23b24f231a46f087413cb3408c2.jpg";